import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { Header } from './components/Header';
import { Footer } from './components/Footer';
import QuickSupport from './components/QuickSupport';
import { Whatsapp } from './components/Whatsapp';
import { InquiryForm } from './components/InquiryForm';
import ScrollToTop from './components/ScrollToTop';
import Loading from './components/Loading';
import UAEPage from "./components/UAEPage";

const Home = React.lazy(() => import('./components/Home'));
const Contact = React.lazy(() => import('./components/Contact'));
const AboutMe = React.lazy(() => import('./components/AboutMe'));
const Articles = React.lazy(() => import('./components/Articles'));
const ServiceDetails = React.lazy(() => import('./components/ServiceDetails'));
const ArticleDetails = React.lazy(() => import('./components/ArticleDetails'));
const Career = React.lazy(() => import('./components/Career'));
const GstCalendar = React.lazy(() => import('./components/GstCalendar'));
const ServicePage = React.lazy(() => import('./components/ServicePage'));
const PrivacyPolicy = React.lazy(() => import('./components/PrivacyPolicy'));
const DeleteAccount = React.lazy(() => import('./components/DeleteAccount'));
const NotFound = React.lazy(() => import('./components/NotFound'));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <QuickSupport />
        <Whatsapp />
        <InquiryForm />
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<AboutMe />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/article-details/:slug" element={<ArticleDetails />} />
            <Route path="/services" element={<ServicePage />} />
            <Route path="/service/:subcategoryName" element={<ServiceDetails />} />
            <Route path="/tax-calendar" element={<GstCalendar />} />
            <Route path='/careers' element={<Career />} />
            <Route path="/business-setup" element={<UAEPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
